import styled from 'styled-components';

export const SearchContainer = styled.div`
  position: relative;
  top: 0;
  width: 0;
  min-width: 50px;
  height: 50px;
  right: ${({ dir }) => (dir === 'rtl' ? '' : '0')};
  left: ${({ dir }) => (dir === 'rtl' ? '0' : '')};
  overflow: hidden;
  -webkit-transition: width 0.3s;
  -moz-transition: width 0.3s;
  transition: width 0.3s;
  backface-visibility: hidden;

  .searchIcon {
    height: 100%;
    width: 100%;
    fill: #fff;
    padding: 20%;
  }

  .sb-icon-search {
    z-index: 12;
    border: 0;
  }

  .sb-search-submit,
  .sb-icon-search {
    width: 50px;
    height: 50px;
    display: block;
    position: absolute;
    left: ${({ dir }) => (dir === 'rtl' ? '0' : '')};
    right: ${({ dir }) => (dir === 'rtl' ? '' : '0')};
    top: 0;
    padding: 0;
    margin: 0;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
    background-repeat: no-repeat;
  }

  @media (min-width: 1100px) {
    .sb-search-submit {
      z-index: 11;
      top: 20px;
      left: ${({ dir }) => (dir === 'rtl' ? '20px' : '')};
      right: ${({ dir }) => (dir === 'rtl' ? '' : '20px')};
    }
  }

  &.sb-search-open {
    @media (min-width: 1100px) {
      width: 100%;
      position: absolute;
      padding: 20px;
      height: auto;
      background: rgba(0, 0, 0, 0.5);
      z-index: 110;

      .sb-search-input {
        position: relative;
        top: auto;
        right: auto;
      }

      .sb-icon-search {
        z-index: 11;
        background-repeat: no-repeat;
        background-color: #000;
        top: 20px;
        left: ${({ dir }) => (dir === 'rtl' ? '20px' : '')};
        right: ${({ dir }) => (dir === 'rtl' ? '' : '20px')};
      }

      .sb-search-submit {
        z-index: 12;
      }
    }

    @media (min-width: 1200px) {
      width: 87vw;
    }

    @media (min-width: 1300px) {
      width: 85vw;
    }

    @media (min-width: 1400px) {
      width: 82vw;
    }

    @media (min-width: 1500px) {
      width: 84vw;
    }

    @media (min-width: 1700px) {
      width: 86.7vw;
    }
  }
`;

export const SearchMobileMenu = styled.div`
  display: none;

  @media (max-width: 1099px) {
    position: relative;
    width: 100%;
    min-width: 50px;
    height: 50px;
    overflow: hidden;
    -webkit-transition: width 0.3s;
    -moz-transition: width 0.3s;
    transition: width 0.3s;
    backface-visibility: hidden;
    display: block;
    background: #333;

    .sb-search-input {
      width: calc(100% - 50px);
      left: 25px;
      right:25px;
    }
  }

  .searchIcon {
    @media (max-width: 1099px) {
      height: 100%;
      width: 100%;
      fill: #fff;
      padding: 20%;
    }
  }

  .sb-icon-search {
    @media (max-width: 1099px) {
      z-index: 12;
      border: 0;
    }
  }

  .sb-search-submit,
  .sb-icon-search {
    @media (max-width: 1099px) {
      width: 50px;
      height: 50px;
      display: block;
      position: absolute;
      left: ${({ dir }) => (dir === 'rtl' ? '25px' : '')};
      right: ${({ dir }) => (dir === 'rtl' ? '' : '25px')};
      top: 0;
      padding: 0;
      margin: 0;
      line-height: 50px;
      text-align: center;
      cursor: pointer;
      background-repeat: no-repeat;
    }
  }
`;

export const MenuCloseButton = styled.div`
  position: absolute;
  left: ${({ dir }) => (dir === 'rtl' ? '15px' : '')};
  right: ${({ dir }) => (dir === 'rtl' ? '' : '15px')};
  top: 54%;
  width: 23px;
  height: 23px;
  z-index: 99;
  display: none;
  cursor: pointer;

  @media (max-width: 1099px) {
    display: none !important;
  }

  &:before {
    position: absolute;
    left: 15px;
    content: ' ';
    height: 23px;
    width: 2px;
    transform: rotate(45deg);
    background-color: #000;
    @media (max-width: 1099.99px) {
      background-color: #fff;
    }
  }

  &:after {
    position: absolute;
    left: 15px;
    content: ' ';
    height: 23px;
    width: 2px;
    background-color: #000;
    transform: rotate(-45deg);

    @media (max-width: 1099px) {
      background-color: #fff;
    }
  }
`;

export const MobileMenuCloseButton = styled.div`
  position: absolute;
  left: ${({ dir }) => (dir === 'rtl' ? '12px' : '')};
  right: ${({ dir }) => (dir === 'rtl' ? '' : '12px')};
  top: 40%;
  width: 23px;
  height: 23px;
  z-index: 99;
  display: none;
  cursor: pointer;

  @media (max-width: 1099px) {
    top: -18px;
    display: block;
    &[dir=ltr] {
      right: 25px;
    }
    &[dir=rtl] {
      left: 25px;
    }
  }

  &:before {
    position: absolute;
    left: 15px;
    content: ' ';
    height: 23px;
    width: 2px;
    transform: rotate(45deg);
    background-color: #000;
    @media (max-width: 1099px) {
      background-color: #fff;
    }
  }

  &:after {
    position: absolute;
    left: 15px;
    content: ' ';
    height: 23px;
    width: 2px;
    background-color: #000;
    transform: rotate(-45deg);

    @media (max-width: 1099px) {
      background-color: #fff;
    }
  }
`;
